
import { Component, Inject, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { switchMap, take } from 'rxjs/operators';
import { FormatService } from './services/administration.ts/format';
import { PacerService } from './services/pacer';
import { ThemeManagerService } from './services/theme-manager';
import { QuantityFormatsService } from './services/administration.ts/quantity-formats';
import { Authentication } from './helpers/authentication';

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  constructor(private _router: Router,
    private _pacerService: PacerService,
    private _themeManager: ThemeManagerService,
    private _formatService: FormatService,
    private _quantityFormatService: QuantityFormatsService,
    private _auth: Authentication,
    @Inject(DOCUMENT) private document: Document) {
    this._router.events.subscribe((e: any) => {
      this.navigationInterceptor(e);
    });

    var currentTheme = localStorage.getItem('enterprise-current-theme');

    if (currentTheme) {
      this._themeManager.setTheme(currentTheme);
    }
    else {
      localStorage.setItem('enterprise-current-theme', 'enterprise');
      this._themeManager.setTheme('enterprise');
    }

    const isAnonymous = location.pathname.toLowerCase().includes('renderreport');
    if (localStorage.getItem('accessToken') && !isAnonymous) {
      this._formatService.getFormats();
      this._quantityFormatService.getQuantityFormatForNumericTextBox();
      this._quantityFormatService.getPipeQuantityFormatSetting();
    }
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.checkRoutePermission(event.url);
    }

    if (this._router.url === '/stock' || this._router.url === '/asset') {
      this.document.body.classList.add('dashboard');
    }
    else {
      this.document.body.classList.remove('dashboard');
    }
  }

  checkRoutePermission(url: string) {
    const isAnonymous = location.pathname.toLowerCase().includes('renderreport');
    if (localStorage.getItem('accessToken') && !isAnonymous) {
      const cleanUrl = url.split('?')[0].replace(/\/$/, '');

      const publicPaths = ['/forgot-password', '/reset-password', '/unlicensed', '/version'];
      if (cleanUrl === '' || cleanUrl === '/' || publicPaths.includes(cleanUrl)) {
        return;
      }

      this._auth.getLicenseObservable().pipe(
        switchMap(() => this._auth.isRouteAllowedObservable(url)),
        take(1)
      ).subscribe(isAllowed => {
        if (!isAllowed) {
          this._router.navigate(['/unlicensed']);
        }
      });
    }
  }
}
